<div class="full-page-container">
  <div class="d-none d-lg-block">
    <fgb-banner [isHomePage]="true"></fgb-banner>
  </div>

  <div class="d-lg-none">
    <div class="scroll-header-container container bg-primary" [ngClass]="{ 'display-header': showTopMenu }">
      <h4 class="name-title mb-0 text-white text-uppercase" *ngIf="memberDetails$ | async as memberDetails">
        {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
      </h4>
      <div class="ms-auto d-flex align-items-center widget-details gap-3">
        <div class="balance-details d-flex bg-glass-dark align-items-center gap-1">
          <span class="icons material-icons font-size-18 text-white" aria-hidden="true">loyalty</span>
          <div class="balance">
            <p class="mb-0 font-size-14 fw-bold text-white">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</p>
          </div>
        </div>

        <button class="qrcode-btn text-white bg-glass-dark" (click)="navigateToWallet()">
          <span class="icon material-icons material-mobile-nav text-white">qr_code_2</span>
        </button>
      </div>
    </div>
  </div>

  <fgb-barcode [isHomePage]="true"></fgb-barcode>

  <div class="container">
    <ng-container *notInProductCode="[productCode.Partners]">
      <!-- Feature challenges -->
      <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true" [link]="'/badges'"></fgbcl-scorecard-carousel>
    </ng-container>

    <!-- Feature rewards -->
    <fgb-featured-rewards-custom></fgb-featured-rewards-custom>

    <!-- Voucher Box -->
    <div *notInProductCode="[productCode.Partners]">
      <fgb-vouchers></fgb-vouchers>
    </div>

    <ng-container *ifScreenSize="screenSize.Mobile">
      <a [href]="'ticket.account' | translate">
        <img class="ticket-account-img" src="assets/images/birdland-ticket-account.jpg" alt="" />
      </a>
    </ng-container>

    <!-- Announcements -->
    <fgbcl-announcements></fgbcl-announcements>
  </div>
</div>
